// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drag-icon {
    width: 60px;
    height: 60px;
  }

  @media (max-width: 440px) {
    .drag-icon {
      width: 60px;
      height: 60px;
    }
  }`, "",{"version":3,"sources":["webpack://./src/pages/Memory_journal/journal.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;EACd;;EAEA;IACE;MACE,WAAW;MACX,YAAY;IACd;EACF","sourcesContent":[".drag-icon {\n    width: 60px;\n    height: 60px;\n  }\n\n  @media (max-width: 440px) {\n    .drag-icon {\n      width: 60px;\n      height: 60px;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
